import React, { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { loginModal} from "../../../../Redux/authAction"
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth} from "../../../../FirebaseConfig";
import Goo from "../../../../assets/icons/Picture1.png"
import login from "../../../../assets/home/gmail.jpg";
import api from "../../../../config/api";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "clamp(750px,100%,300px)",
  height: "600px",
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  p: 4,
};

const TopBar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.authReducer.isAuthenticated);
  const loginModalOpen = useSelector((state) => state.authReducer.loginModal);
  const loginModalValue = useSelector((state) => state.authReducer.loginModal);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");


  const [pkgid, setpkgid]= useState('');
  const [pkgstatus, setpkgstatus]= useState('')

  const isLang = useSelector((state) => state.authReducer.lang);
 
  const [logEmail, setLogEmail] = useState("");
  const [logPassword, setLogPassword] = useState("");
  const [openModel, setOpenModel] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleOpen = () => dispatch(loginModal(true));
  const handleClose = () => dispatch(loginModal(false));

  const handleSignup = async () => {
    try {
      if (name && email && password) {
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );
        await updateProfile(userCredential.user, {
          displayName: name,
        });
        setSnackbarSeverity("success");
        setSnackbarMessage("Signup successful!");
        setSnackbarOpen(true);
        handleCloseModel();
      } else {
        setSnackbarSeverity("error");
        setSnackbarMessage("Please enter valid name, email, and password.");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error during signup:", error);
      let errorMessage = "Unexpected error occurred.";
      if (error.code === "auth/operation-not-allowed") {
        errorMessage =
          "Firebase authentication operation not allowed. Check Firebase Console settings.";
      }
      setSnackbarSeverity("error");
      setSnackbarMessage(errorMessage);
      setSnackbarOpen(true);
    }
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

   
    setSnackbarOpen(false);
  };
  
  const handleLogin = async () => {
    try {
      if (logEmail && logPassword) {
        // Sign in with email and password
        const userCredential = await signInWithEmailAndPassword(auth, logEmail, logPassword);
        const user = userCredential.user;
        const { displayName, email, uid } = user;
  
        // Send UID to fetch subscription data
        const formData = new FormData();
        formData.append("uid", uid);
  
        const response = await fetch(api.getUrl(api.ENDPOINTS.GET_SUBSCRIPTION_DATA), {
          method: "POST",
          body: formData,
        });
  
        if (!response.ok) {
          throw new Error("Failed to fetch subscription data.");
        }
  
        const data = await response.json();
  
        if (data.status === "success" && data.data.length > 0) {
          const subscription = data.data[0]; // Get the first subscription record
          const { packageid, status } = subscription;
  
          // Dispatch login details to Redux
          dispatch(loginUser({ displayName, email, uid, packageid, status }));
  
          // Show success snackbar
          setSnackbarSeverity("success");
          setSnackbarMessage(isLang === "arabic" ? "تسجيل الدخول بنجاح!" : "Login successful!");
          setSnackbarOpen(true);
          // Close login modal
          dispatch(loginModal(false));
        } else {
          // If no subscription found, show an error
          setSnackbarSeverity("error");
          setSnackbarMessage(isLang === "arabic" ? "لم يتم العثور على اشتراك." : "No subscription found.");
          setSnackbarOpen(true);
        }
      } else {
        // If email or password is missing, show an error
        setSnackbarSeverity("error");
        setSnackbarMessage(isLang === "arabic" ? "يرجى إدخال البريد الإلكتروني وكلمة المرور." : "Please enter both email and password.");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Login Error:", error.message);
  
      // Show error snackbar
      setSnackbarSeverity("error");
      setSnackbarMessage(isLang === "arabic" ? "فشل تسجيل الدخول. تحقق من بياناتك." : "Failed to login. Please check your credentials.");
      setSnackbarOpen(true);
    }
  };

  const handleGoogleLogin = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then(() => {
        setSnackbarSeverity("success");
        setSnackbarMessage("Google login successful!");
        setSnackbarOpen(true);
        handleClose();
      })
      .catch(() => {
        setSnackbarSeverity("error");
        setSnackbarMessage("Failed to login with Google.");
        setSnackbarOpen(true);
      });
  };
  const handelOpenModel = () => {
    dispatch(loginModal(false))
    setOpenModel(true);
  };
  const handleCloseModel = () => setOpenModel(false);
  
  return (
    <>
      <nav className="w-full h-12 flex justify-between items-center px-6 py-2 bg-purple-600 text-white shadow-lg">
        <div className="flex items-center space-x-6">
          <button
            onClick={() => navigate("/")}
            className="flex items-center text-md font-semibold hover:text-gray-300 transition-colors"
          >
            <FaArrowLeft className="mr-2" /> Home
          </button>
        </div>
        <h1 className="text-3xl font-bold">Video Editor</h1>
        <div>
          {!isAuthenticated ? (
            <button onClick={handleOpen} className="text-white font-semibold">
              Sign In
            </button>
          ) : (
            <p>Welcome Back!</p>
          )}
        </div>
      </nav>

      {/* Login Modal */}
      {/* <Modal
        open={loginModalValue}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="rounded-lg text-[#262b33]">
          <div className="flex ">
            <div className="w-[50%] h-[70vh] flex flex-col  gap-4 mr-7 ml-2">
              <p className="mb-[30px] mt-[20px] text-[28px] font-[700] relative -left-3">
                Welcome back!
              </p>
              <div>
                <p>Email:</p>
                <input
                  type="text"
                  placeholder="Email"
                  value={logEmail}
                  onChange={(e) => setLogEmail(e.target.value)}
                  className="p-2 border-2 rounded focus:outline-blue-500 w-full bg-slate-50"
                />
              </div>
              <div className="">
                <p>Password</p>
                <input
                  type="password"
                  placeholder="Password"
                  value={logPassword}
                  onChange={(e) => setLogPassword(e.target.value)}
                  className="p-2 border-2 rounded focus:outline-blue-500 w-full bg-slate-50"
                />
              </div>
              <div className="w-full flex justify-end items-center">
                <a href="/forgetpassword">Forget Password?</a>
              </div>
              <button
                onClick={handleLogin}
                className="bg-gradient-to-r from-[#4c76cf] to-[#552ab8] px-7 py-3 rounded-md text-white text-[16px] font-[600] cursor-pointer "
              >
                Login
              </button>
              <button
                onClick={handleGoogleLogin}
                className="flex items-center bg-white dark:bg-gray-900 border border-gray-300 rounded-lg shadow-md px-6 py-2 text-sm font-medium text-gray-800 dark:text-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
              >
                <img src={`${Goo}`} className="h-8" />
                <span>Continue with Google</span>
              </button>
              <div style={{ display: "flex", gap: "4px" }}>
                <p>Do Not Have an Account: </p>{" "}
                <button
                  onClick={handelOpenModel}
                  className="focus:outline-none active:outline-none  text-[#3b603d] font-[600] hover:underline"
                >
                  {" "}
                  SignUp
                </button>
              </div>
            </div>

            <div className="w-[50%] h-[100%] bg-slate-600 overflow-hidden">
              <img src={`${login}`} className="h-full" alt="" />
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openModel}
        onClose={handleCloseModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="rounded-lg text-black">
          <div className="flex ">
            <div className="w-[50%] h-[70vh] flex flex-col  gap-4 mr-7 ml-2">
              <p className="mb-[30px] mt-[20px] text-[28px] font-[700] relative -left-3">
                Maker4U!
              </p>
              <div>
                <label>Name:</label>
                <input
                  type="text"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full h-9 bg-white    focus:outline-none pl-2"
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                    borderRadius: "5px",
                    border: "1px solid #63626240",
                  }}
                />
              </div>
              <div>
                <label>Email:</label>
                <input
                  type="text"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full h-9 bg-white    focus:outline-none pl-2"
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                    borderRadius: "5px",
                    border: "1px solid #63626240",
                  }}
                />
              </div>
              <div className="">
                <label>Password</label>
                <input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full h-9 bg-white    focus:outline-none pl-2"
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                    borderRadius: "5px",
                    border: "1px solid #63626240",
                  }}
                />
              </div>
              <button
                onClick={handleSignup}
                className="bg-gradient-to-r from-[#4c76cf] to-[#552ab8]  py-2 rounded-md text-white text-[16px] font-[600] cursor-pointer "
              >
                Signup
              </button>
              <button
                onClick={handleGoogleLogin}
                className="flex items-center bg-white dark:bg-gray-900 border border-gray-300 rounded-lg shadow-md px-4 py-[6px] text-sm font-medium text-gray-800 dark:text-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
              >
                <img src={`${Goo}`} className="h-8 " />
                <span>Continue with Google</span>
              </button>

              <div className="flex gap-1">
                <p>Already Have an Account:</p>
                <button
                  onClick={handleOpen}
                  className="focus:outline-none active:outline-none  text-[#3b603d] font-[600] hover:underline"
                >
               
                  SignIn
                </button>
              </div>
            </div>

            <div className="w-[50%] h-[100%] bg-slate-600 overflow-hidden">
              <img src={`${login}`} className="h-full" alt="" />
            </div>
          </div>
        </Box>
      </Modal> */}

      {/* Snackbar for messages */}
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity} elevation={6} variant="filled">
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default TopBar;
